module.exports = __webpack_public_path__ + "media/images/icons/times-solid-6872f2e0d9d7bda6b9b253072f8ab0ef.svg";